import { render, staticRenderFns } from "./VerifyTwoFaAntispam.vue?vue&type=template&id=7a968adc&scoped=true&"
import script from "./VerifyTwoFaAntispam.vue?vue&type=script&lang=js&"
export * from "./VerifyTwoFaAntispam.vue?vue&type=script&lang=js&"
import style0 from "./VerifyTwoFaAntispam.vue?vue&type=style&index=0&id=7a968adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a968adc",
  null
  
)

export default component.exports